import { render, staticRenderFns } from "./BookInformationPreview.vue?vue&type=template&id=38ead29c&scoped=true"
import script from "./BookInformationPreview.vue?vue&type=script&lang=js"
export * from "./BookInformationPreview.vue?vue&type=script&lang=js"
import style0 from "./BookInformationPreview.vue?vue&type=style&index=0&id=38ead29c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ead29c",
  null
  
)

export default component.exports